import lodash, { find, get } from 'lodash'
import React, { useEffect } from 'react'
import { ReactElement } from 'react'
import styled from 'styled-components'

import Field, {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import { required } from '../../../../../../../1stlog-ui/src/components/Field/Validation'
import Select from '../../../../../../../1stlog-ui/src/components/Select'
import { useProductSettings } from '../../../../Products'
import useOrderEntry from '../../../../useOrderEntry'

const Wrapper = styled.div`
  min-width: 150px;
`

type TFreightTermProps = {
  readonly?: boolean
  isOptional?: boolean
}

const FreightTerm = (props: TFreightTermProps): ReactElement => {
  const { readonly, isOptional } = props

  const { isOrderEditor } = useOrderEntry()

  const {
    allowedFreightTermList = [],
    isFreightTermsAllowed,
    defaultFreightTerm,
  } = useProductSettings()

  const options = allowedFreightTermList.map((o) => ({
    value: o.key,
    label: o.name,
  }))

  const [freightTerms, setFreightTerms] = useField('freightTerms', {
    asState: true,
  })

  useEffect(() => {
    // not allowed anymore or option not available anymore
    if (
      !isFreightTermsAllowed ||
      !lodash.find(options, (o) => o.value === freightTerms)
    ) {
      setTimeout(() => setFreightTerms(undefined), 0)
    }

    // set first option by default
    if (
      !readonly &&
      !freightTerms &&
      !isOptional &&
      isFreightTermsAllowed &&
      !lodash.isEmpty(options)
    ) {
      setTimeout(
        () =>
          setFreightTerms(
            defaultFreightTerm || lodash.get(lodash.first(options), 'value'),
          ),
        0,
      )
    }
  }, [isFreightTermsAllowed, defaultFreightTerm, freightTerms])

  if (!isFreightTermsAllowed) {
    return <></>
  }

  return (
    <>
      {readonly && (
        <div className="text-center">
          <div>
            <Label>{i18n.t('freight_term', 'Frankatur')}</Label>
          </div>
          <h4 className="mt-1">
            {get(
              find(options, (o) => o.value === freightTerms),
              'label',
              freightTerms,
            )}
          </h4>
        </div>
      )}
      <Wrapper hidden={readonly}>
        <Field
          key={`freightTerms_${isOrderEditor}`}
          name="freightTerms"
          label={i18n.t('freight_term', 'Frankatur')}
          required={!isOrderEditor}
          validate={isOrderEditor ? undefined : required}
        >
          <Select options={options} direct clearable={isOrderEditor} />
        </Field>
      </Wrapper>
    </>
  )
}

export default FreightTerm
